import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
    state() {
        return {
            tooltip: {
                text: '',
                active: false
            },
            songs: []
        }
    },
    mutations,
    getters,
    actions
});